<template>
  <v-container fluid fill-height pa-0 ma-0>
    <!--   <v-system-bar window dark app color="primary">
      <v-icon>mdi-timer</v-icon>
      <span
        >[ 02/07/2019 12:00pm ] Mantenimiento programado de la plataforma</span
      >
      <v-spacer></v-spacer>
      <v-icon>mdi-close</v-icon>
    </v-system-bar>
 -->
    <v-app-bar app elevation="0" color="transparent" clipped-right clipped-left>
      <img
        v-if="!$vuetify.breakpoint.mdAndUp"
        src="@/assets/logo-white.svg"
        alt="avatar"
        width="200"
      />
      <v-divider
        v-if="!$vuetify.breakpoint.mdAndUp"
        class="mx-4 hidden-xs-only"
        inset
        vertical
      ></v-divider>
      <span
        v-if="!$vuetify.breakpoint.mdAndUp"
        class="subheading hidden-xs-only"
        >Inteligencia Empresarial para Compras Públicas</span
      >
      <v-spacer></v-spacer>

      <language></language>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-content pa-0 ma-0>
      <!-- Provides the application the proper gutter -->
      <v-container fluid pa-0 ma-0>
        <!-- If using vue-router -->
        <v-layout align-center justify-center>
          <v-img
            src="@/assets/intro.svg"
            aspect-ratio="1"
            max-width="520"
            class="hidden-sm-and-down"
            max-height="420"
          ></v-img>
          <v-divider class="mx-5 hidden-sm-and-down" vertical></v-divider>
          <custom-amplify-authenticator v-bind:authConfig="authConfig" />
        </v-layout>
      </v-container>
    </v-content>

    <v-footer app color="transparent">
      <v-row align-content="center" justify="center">
        <v-col class="text-center body-2 ma-0 pa-0">
          &reg; Inteldatos 2021 -
          {{ this.$Amplify.I18n.get("All rights reserved") }}
        </v-col>
      </v-row>
    </v-footer>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { components } from "@/components";
import { signUpConfig } from "@/components/authenticator/config";
import Language from "@/components/Language";
export default {
  components: {
    ...components,
    Language
  },
  data() {
    return {
      authConfig: {
        signUpConfig
      }
    };
  },
  methods: {
    ...mapActions(["setFiltersAction", "setQueriesAction"])
  },
  mounted() {
    console.log("Auth Mounted");
    this.setFiltersAction([]);
    this.setQueriesAction([]);
  }
};
</script>
